import React from "react";

const Kitesurfing = () => {
  return (
    <>
      <h1>What kind of Kitesurfing?</h1>
    </>
  );
};

export default Kitesurfing;
